import { render, staticRenderFns } from "./BadgeCommit.vue?vue&type=template&id=773e770a&scoped=true"
import script from "./BadgeCommit.vue?vue&type=script&lang=js"
export * from "./BadgeCommit.vue?vue&type=script&lang=js"
import style0 from "./BadgeCommit.vue?vue&type=style&index=0&id=773e770a&prod&scoped=true&lang=scss"
import style1 from "./BadgeCommit.vue?vue&type=style&index=1&id=773e770a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e770a",
  null
  
)

export default component.exports